
import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class DocumentMixin extends Vue {
  public blurElementById = (id: string) => document.getElementById(id).blur();
}
